// extracted by mini-css-extract-plugin
export default {"hiddenClearButton":"FoodSearchInput_hiddenClearButton__j1jxP","input":"FoodSearchInput_input__CqlAB","row":"FoodSearchInput_row__qUXBa"};